import React from 'react';

const ContactBanner = () => {
  return (
    <div className="about-banner contact-banner">
      <div className="container">
        <div className="banner-heading">
          <h1>Contact Us</h1>
          <div className="divider-shape"></div>
        </div>
      </div>
    </div>
  );
};

export default ContactBanner;
